export default __webpack_public_path__ + "static/media/icon_loading.68574257.svg";